import { modifier } from 'ember-modifier';

export default modifier((element: HTMLElement, [key, action]: [string, (event: KeyboardEvent) => void]) => {
  const keyupHandler = (event: KeyboardEvent): void => {
    if (event.key !== key) return;
    action(event);
  };

  element.addEventListener('keyup', keyupHandler);
  return () => {
    element.removeEventListener('keyup', keyupHandler);
  };
});
